import { Request } from '@/services/api';
import { ISendTemplateEmailPayload } from '@/store/modules/emails-management';

export class EmailsManagementService {
  static listTemplates() {
    return Request().get(`/admin/emails-management/templates`);
  }

  static getTemplate(id: string) {
    return Request().get(`/admin/emails-management/templates/${encodeURIComponent(id)}`);
  }

  static sendTemplate(payload: ISendTemplateEmailPayload) {
    return Request().post(`/admin/emails-management/send-template`, payload);
  }
}
